import { useSearchParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import ContactThreadWindow from "@/components/contact/ContactThreadWindow";

const ContactConversation = () => {
  const [params] = useSearchParams();
  const id = params.get("id") || undefined;
  const token = params.get("token") || undefined;

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Votre conversation avec le support | Click&Gard"
        description="Suivez et poursuivez votre échange avec l'équipe Click&Gard dans un fil de conversation sécurisé."
        noIndex
      />
      <Navbar />
      <main className="container mx-auto px-4 py-6 max-w-3xl">
        <h1 className="text-2xl font-bold mb-4">Votre conversation</h1>
        <Card>
          <CardContent className="p-4 h-[75vh] flex flex-col">
            {id || token ? (
              <ContactThreadWindow conversationId={id} token={token} />
            ) : (
              <div className="text-center py-10 space-y-3">
                <p className="text-sm text-muted-foreground">
                  Lien de conversation invalide ou incomplet.
                </p>
                <Button asChild variant="outline">
                  <Link to="/contact">Nous contacter</Link>
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default ContactConversation;
